import React, { useState } from "react";
import { Link } from "react-router-dom";
import { DepositModal } from "./DepositModal";

const DepositStrip = () => {
  const [depositAmount, setDepositAmount] = useState("");
  const [openDepositModal, setOpenDepositModal] = useState(false);
  const handleDeposit = (amount) => {
    // handle deposit
    setOpenDepositModal(false);
    setDepositAmount("");
  };
  return (
    <>
      {openDepositModal && (
        <DepositModal
          depositAmount={depositAmount}
          setDepositAmount={setDepositAmount}
          onClose={() => setOpenDepositModal(false)}
          onDeposit={handleDeposit}
        />
      )}

      <div className="max-md:block hidden relative top-0">
        <Link
          to="/"
          className="bg-yellow py-1 px-2 flex justify-between gap-3 items-center"
        >
          <p className="text-darkblue/80 dark:text-darkblue text-xs !leading-none font-normal">
            M-PESA Paybill:<strong>290898</strong> Airtel Money:{" "}
            <strong>290898</strong>
          </p>
          <span
            onClick={() => setOpenDepositModal(true)}
            className="text-darkblue dark:text-darkblue text-xs !leading-none font-bold underline"
          >
            Click to deposit
          </span>
        </Link>
      </div>
    </>
  );
};

export default DepositStrip;
